import React, { useEffect, useState } from "react";
import { Content, Body } from './styles';
import { Button, Checkbox, DefaultInput, DefaultSelect } from "ui-kit-takeat";

function EditNFE({ restaurantData, setRestaurantData,deleteClubeModal,setDeleteClubeModal }) {
    const [selectedCrmPlan, setSelectedCrmPlan] = useState(null)
    const crmPlanOptions = [
        {
            value: '',
            label: 'Sem plano'
        },
        {
            value:'silver',
            label:'Silver'
        },
        {
            value:'gold',
            label:'Gold'
        },
        {
            value:'infinit',
            label:'Infinit'
        }
    ]
    const handleChange = (field, value) => {
        setRestaurantData((prevData) => ({
            ...prevData,
            [field]: value,
        }));
    };

    useEffect(()=>{
        if (restaurantData?.settings.crm_plan) {
            setSelectedCrmPlan(crmPlanOptions.find((plan) => plan.value === restaurantData?.settings.crm_plan))
        }

    },[restaurantData])

    return (
        <Content>
            <span style={{ fontFamily: 'Poppins', fontSize: 20, fontWeight: 500 }}>
                Clube
            </span>
            <Body>
                <Checkbox
                    label="Takeat Club ativo"
                    checked={restaurantData?.has_clube}  
                    onClick={(e) => handleChange('has_clube', e)}  
                    containerStyles={{
                        gridArea: "nfce"
                    }}
                />
                <DefaultInput
                    title="Token Takeat Club"
                    value={restaurantData?.token_clube}  
                    onChange={(e) => handleChange('token_clube', e.target.value)} 
                    containerStyles={{
                        gridArea: "takeatToken",
                    }}
                    style={{ height: 40 }}
                />
                <Button
                    title="Deletar clube"
                    buttonColor="#C8131B"
                    onClick={() => setDeleteClubeModal(!deleteClubeModal)} 
                    containerStyles={{
                        gridArea: "deletebutton",
                        height: 40
                    }}
                />
                <DefaultSelect
                    label="Plano CRM"
                    value={selectedCrmPlan}
                    onChange={(e) => {
                        setRestaurantData((prevData) => ({
                            ...prevData,
                            settings: {
                                ...prevData.settings,
                                crm_plan: e.value
                        }}));
                        setSelectedCrmPlan(e)
                    }}  
                    containerStyles={{
                        gridArea: "crmPlan"
                    }}
                    options={crmPlanOptions}
                />
                <DefaultInput
                    title="Custo do CRM:"
                    value={restaurantData?.settings.crm_campaign_fee}
                    type="number"
                    onChange={(e) => {
                        setRestaurantData((prevData) => ({
                            ...prevData,
                            settings: {
                                ...prevData.settings,
                                crm_campaign_fee: e.target.value
                        }}));
                    }} 
                    containerStyles={{
                        gridArea: "crmFee",
                    }}
                    style={{ height: 40 }}
                />
            </Body>
        </Content>
    );
}

export default EditNFE;
